import { useState, useContext, createContext, useEffect } from "react";
import Cookies from "js-cookie";

const AuthContext = createContext();

// Static User Data (for now)
const staticUser = {
  username: "admin",
  password: "admin123",
  token: "static-token",
};

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check for a token in cookies when the app first loads
  useEffect(() => {
    const storedToken = Cookies.get("tkn");
    if (storedToken) {
      setToken(storedToken);
    }
    setLoading(false);
  }, []);

  // Function to authenticate the user
  const authenticate = (username, password) => {
    if (username === staticUser.username && password === staticUser.password) {
      setToken(staticUser.token);
      Cookies.set("tkn", staticUser.token, { expires: 1 }); // Set cookie to expire in 1 day
      return true;
    } else {
      setToken(null);
      Cookies.remove("tkn"); // Remove cookie if authentication fails
      return false;
    }
  };

  const logout = () => {
    setToken(null);
    Cookies.remove("tkn"); // Remove the token from cookies
  };

  return (
    <AuthContext.Provider value={{ token, authenticate, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook to use AuthContext
export const useAuth = () => {
  return useContext(AuthContext);
};
